import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_PHASE4 = defineFcm('starter_experience_dashboard_phase4')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_dashboard_phase4_experiment',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description: 'Controls the visibility of the Starter Experience Dashboard Phase 4 features.',
		import: false,
		template: {
			experimentName: 'starter_experience_dashboard_phase4_experiment',
			enabled: false,
		},
	});
